import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

export default function InstallBanner() {
  const [prompt, setPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(() => { try { return localStorage.getItem("tga-install-dismissed") === "1"; } catch { return false; } });
  const [showIOS, setShowIOS] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const onInstalled = () => setPrompt(null);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  if (dismissed || isStandalone()) return null;
  const ios = isIOS();
  if (!prompt && !ios) return null;

  const dismiss = () => { setDismissed(true); try { localStorage.setItem("tga-install-dismissed", "1"); } catch {} };
  const install = async () => {
    if (prompt) {
      prompt.prompt();
      const { outcome } = await prompt.userChoice;
      if (outcome === "accepted") setPrompt(null);
    } else {
      setShowIOS((v) => !v);
    }
  };

  return (
    <div className="tga-card-dark mb-6 flex items-start gap-3" data-testid="install-banner">
      <img src="/icon-192.png" alt="" className="w-11 h-11 rounded-xl shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="font-display text-[color:var(--brass-bright)] text-lg leading-tight">Add TGA to your home screen</div>
        <p className="text-xs text-[color:var(--muted-green)] mt-0.5">Opens full-screen like an app — handy on the course.</p>
        {showIOS && (
          <p className="text-xs mt-2 text-[color:var(--text-cream)]" data-testid="install-ios-hint">
            In Safari tap <Share size={12} className="inline -mt-0.5" /> <strong>Share</strong>, then <strong>Add to Home Screen</strong>.
          </p>
        )}
        <button data-testid="install-app-btn" onClick={install} className="brass-btn rounded-lg px-3 py-1.5 text-xs inline-flex items-center gap-1 mt-2">
          <Download size={12} /> {prompt ? "Install app" : "How to install"}
        </button>
      </div>
      <button data-testid="install-dismiss-btn" onClick={dismiss} className="ghost-btn rounded-lg p-1.5" aria-label="Dismiss"><X size={14} /></button>
    </div>
  );
}
